/**
 * The UOM-mismatch alert (prototype `vSuppliers`, the danger-styled banner).
 *
 * The prototype hardcodes one sentence about Gulf Provisions and the oil filter. Here every
 * flagged mismatch is listed, because a real reply set can contain several — and each gets
 * its conversion spelled out ("1 box = 24 pcs") so the purchaser can act without opening the
 * item master.
 */

import { Badge } from '../../components/Badge'
import { conversionHint, type UomMismatch } from '../../lib/sq'

export function UomMismatchBanner({ mismatches }: { mismatches: UomMismatch[] }) {
  if (mismatches.length === 0) return null

  return (
    <div
      className="banner"
      // The prototype overrides the banner to danger tones for this one alert.
      style={{ background: 'var(--dangerbg)', borderColor: 'var(--dangerline)' }}
      role="alert"
    >
      ⚠ <b>UOM mismatch</b> on {mismatches.length} line{mismatches.length === 1 ? '' : 's'} — convert before comparing.
      {mismatches.map((m) => {
        const hint = conversionHint(m)
        return (
          <div key={`${m.sq_id}-${m.item_code}`} style={{ marginTop: 6 }}>
            <b>{m.supplier}</b> quoted <b>{m.item_name}</b> in <b>{m.sq_uom}</b> but the RFQ was in{' '}
            <b>{m.rfq_uom}</b>
            {hint ? (
              <>
                {' — '}
                <Badge tone="info">{hint}</Badge>
              </>
            ) : (
              <>
                {' — '}
                <Badge tone="warn">no conversion in the item master</Badge>
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}
